<template>
  <div class="box14">
    <div class="left-box">
      前端学习路线图
      <div class="tagBox">
        <p>自学必看</p>
        <p>零基础</p>
        <p>新版</p>
      </div>
      <div class="left-btn" @click="goHref">免费领取</div>
    </div>

    <img
      class="box14-icon"
      src="../../../assets/coursePage/web/box15/icon.png"
      alt
    />
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    goHref() {
      this.mai("HTML&JS+前端-就业课","免费领取",0,null)
      window.open("https://m.boxuegu.com/route/web");
    },
  },
};
</script>

<style lang="scss" scoped>
.box14 {
  position: relative;
  width: 100%;
  height: 240px;
  box-sizing: border-box;
  background: url("../../../assets/coursePage/web/box15/bgc.png") no-repeat;
  background-size: cover;
  .left-box {
    position: absolute;
    top: 32px;
    left: 48px;
    font-size: 40px;
    font-family: PingFangSC-Semibold;
    font-weight: 600;
    color: #ffffff;
    line-height: 56px;
    .tagBox {
      text-align: center;
      display: flex;
      margin-top: 8px;
      p {
        width: 120px;
        height: 36px;
        background: rgba(255, 255, 255, 0.3);
        border-radius: 28px;
        font-size: 22px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #ffffff;
        line-height: 36px;
        margin-right: 8px;
      }
    }
    .left-btn {
      margin-top: 24px;
      width: 160px;
      height: 52px;
      background: #ffffff;
      border-radius: 8px;
      text-align: center;
      font-size: 24px;
      font-family: PingFangSC-Medium;
      font-weight: 500;
      color: #00b589;
      line-height: 52px;
    }
  }

  .box14-icon {
    position: absolute;
    right: 0px;
    top: -16px;
    width: 324px;
    height: 256px;
  }
}
</style>
